import 'react-native-reanimated'
import 'react-native-gesture-handler'
import { registerRootComponent } from 'expo'
import { App } from 'app'
import './reset.css'

registerRootComponent(App)
